<template>
    <div style="display: flex;gap: 10px;align-items: flex-end;">
    <Dropdown trigger="hover" :popup-max-height="500" v-model:popup-visible="visible"  >
        <Input :class="{'is-error': status}" v-model="inputValue" :readonly="true" style="width: 114px;"   allow-clear @mousedown.stop.prevent @click.stop.prevent @mouseup.stop.prevent tabindex="-1">
            <template #append>
                 <span  v-html="append"></span>
            </template>
        </Input>
        <template #content> 
            <div style="width: 600px;padding: 10px;">
                <RadioGroup v-model="radioValue" @change="handleChange">
                <Radio style="width: 60px;"  v-for="item in presetNumbers" :key="item"  :value="item" >
                    {{ item }}
                </Radio>
            </RadioGroup>
            </div>
            <div class="other-input" v-if="otherInput" style="display: flex;flex-wrap: nowrap;gap: 10px;justify-content: center;align-items: center; padding: 10px 20px;">
                <b style="font-size: 16px;margin-right: 10px;width: 280px;">{{ otherText }}</b>
                <InputNumber :hide-button="true" :step="1" :precision="0" :min="min" :max="max" v-model="inputVal"  placeholder="" ></InputNumber>
                <Button type="primary" @click="handleChangeSure">{{ submitText }}</Button>
                <Button  @click="visible=false">{{ cancelText }}</Button>
            </div>
            <p style="color:#f90;padding: 0px 20px;">(The qty must be over 200 and should be multiples of 10.)</p>
        </template>
    </Dropdown>
    <span style="line-height: 20px;" v-html="props.footer"></span>
    </div>
</template>
<script setup>
import { ref ,computed,nextTick,inject,watch} from 'vue';
import { Input,Dropdown,Radio,InputNumber,RadioGroup,Button } from '@arco-design/web-vue';
import { formItemInjectionKey } from "@arco-design/web-vue/es/form/context";
const formItemCtx = inject(formItemInjectionKey, null);
const status = computed(() => {
  return formItemCtx?.error;
});
defineOptions({
    name:"pcb-layer"
})
const inputVal=ref(null)
const emits=defineEmits(["change"])
const visible=ref(false)
const radioValue=ref(null)
const modelValue=defineModel({
    type: [String, Number],
    default: ''
})
const presetNumbers = [
  5, 10, 15, 20, 25, 30, 50, 75, 100, 125, 150, 200,
  250, 300, 350, 400, 450, 500, 600, 700, 800, 900, 1000, 1200,
  1500, 1600, 1750, 1800, 2000, 2400, 2500, 2800, 3000, 3500, 4000, 4500,
  5000, 5500, 6000, 6500, 7000, 7500, 8000, 8500, 9000, 9500, 10000,11000,12000,13000,14000,15000,16000,17000,18000
];
const inputValue=computed(()=>{
    return modelValue?.value ? String(modelValue.value) : ""
})
watch(()=>modelValue.value,(newVal)=>{
    if(newVal&&newVal!==''&&presetNumbers.includes(Number(newVal))){
        radioValue.value=Number(newVal)
    }
},{immediate:true,deep:true})
const props=defineProps({
    dicData:{
        type:Array,
        default:()=>[]
    },
    footer:{
        type:String,
        default:''
    },
    append:{
        type:String,
        default:'pcs'
    },
    otherInput:{
        type:Boolean,
        default:true
    },
    otherText:{
        type:String,
        default:'Other Quantity:'
    },
    cancelText:{
        type:String,
        default:'cancel'
    },
    submitText:{
        type:String,
        default:'submit'
    },
    min:{
        type:Number,
        default:0
    },
    max:{
        type:Number,
        default:1000000000
    }
})
function handleChange(){
    modelValue.value=Number(radioValue.value)
    visible.value=false
    nextTick(()=>{
        emits("change",modelValue.value)
    })
}
function handleChangeSure(){
    if(inputVal.value<200){
        layer?.msg("The qty must be over 200")
        return
    }
    if(inputVal.value%10!==0){
        layer?.msg("The qty must be multiples of 10.")
        return
    }
    modelValue.value=Number(inputVal.value)
    visible.value=false
    nextTick(()=>{
        emits("change",modelValue.value)
    })
}

</script>
<style scoped lang="less">
:deep(.arco-radio-label){
    font-weight: 400;
    color:#333;
}
.is-error{
  &:deep(.arco-input-wrapper){
    -webkit-animation: pcb-glow 800ms ease-out infinite alternate;
    animation: pcb-glow 800ms ease-out infinite alternate;
  }
}
.other-input .arco-input-wrapper{
        border: 1px solid var(--color-border-3) !important;
}
:deep(.arco-input-wrapper){
    padding-left: 7px !important;
    padding-right: 7px !important;
    border-radius: 0px;
    color:#333333 !important;
    height: 28px !important;
  }
  
  :deep(.arco-input-append){
    padding: 0px !important;
    min-width: 28px !important;
    text-align: center !important;
    color:#666666 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 0 !important;
    font-size: 12px !important;
    padding: 3px !important;
  }
</style>